<template>
	<div class="cropper--wrap flex direction-column align-center" :class="{isOpenCropper: img}">
		<div class="cropper__container">

			<div class="cropper" ref="cropper">
				<div
					class="cropper__dragFileReader flex align-center justify-center"
					:class="{active: isDrag}"
				>
					{{ $t('cropper.dragFilesHere') }}
				</div>
				<clipper-basic
					ref="clipper"
					:src="img"
					:ratio="1"
					:corner="true"
					:grid="true"
					:wrapRatio="1"
					:preview="'preview'"
					:class="{hidden: img}"
				>
					<div slot="placeholder"><span class="cropper__placeholder"></span></div>
				</clipper-basic>
			</div>

			<label class="cropper__chose">
				<input type="file" accept="image/x-png,image/gif,image/jpeg" @change="upload($event.target)">
				<span class="cropper__choseBtn">
				<i class="fa fa-arrow-circle-o-up"></i>
				{{ fileName ? `${fileName}.${fileExtension}` : $t('cropper.choseBtn') }}
			</span>
			</label>

			<transition name="slide-fade">
				<p class="NS-label__input--errormessage cropper__error" v-if="error">{{ errorText }}</p>
			</transition>
		</div>

		<transition name="slide-fade">
			<p class="cropper__preview__title" v-if="!!templateId">
				{{ $t('cropper.previewTitle') }}
			</p>
		</transition>

		<transition name="slide-fade">
			<div class="cropper__preview"
				 v-show="!!templateId"
				 :style="previewStyle"
				 ref="preview"
			>
				<clipper-preview
					:name="'preview'"
					:class="{sales: templateId === 2}"
				></clipper-preview>
				<div ref="previewSignature">
					<div>
						<div style="max-height: 300px; opacity: 1;">
							<div style="max-width:600px;  direction: ltr; ">
								<div style="max-width: 470px;margin: 8px 8px 8px 0;">
									<div style="text-align: initial;font: 12.8px Arial;color: #646464;">--</div>
									<div
										style="text-align: initial;font: 14px Arial;color: #646464;padding: 0 10px 10px 0;">
										Best regards,
									</div>
									<table border="0" cellspacing="0" cellpadding="0"
										   style="width: 100%; max-width: 470px">
										<tbody>
										<tr valign="top">
											<td style="padding-left: 5px;width: 10px;padding-right: 12px;">
												<img
													:class="{hideImage: !resultURL}"
													:src="resultURL" :width="imageWidth" :height="imageWidth"
													:alt="formData.name"
													:style="`border-radius:50%;moz-border-radius:50%;khtml-border-radius:50%;o-border-radius:50%;webkit-border-radius:50%;ms-border-radius: 50%;width: ${imageWidth}px;height: ${imageWidth}px;max-width: 120px;`">
											</td>
											<td style="border-right: 2px solid #33a1fd;"></td>

											<td style="text-align:initial; font:14px Arial;color:#646464;padding:0 10px"
												v-if="templateId === 1">
												<div style="margin-top: 5px;">
													<b style="font-size: 16px;word-break: break-all;">{{ formData.name
														||
														$t('createForm.formData.name')}}</b>
													<br>
													<span style="word-break: break-all;">{{ formData.position ||
															$t('createForm.formData.position')}}</span>,
													<span style="word-break: break-all;">{{ formData.company ||
															$t('createForm.formData.company')}}</span>
												</div>

												<div style="color:#8d8d8d;font-size:13px;padding:5px 0;">
										<span style="display:inline-block;">
											<a :href="generateEmailHref(formData.email)"
											   style="color:#8d8d8d;text-decoration: none;word-break: break-all;"
											>{{ formData.email || 'example@mail.com' }}</a>
										</span>
												</div>
											</td>
											<td style="text-align:initial; font:14px Arial;color:#646464;padding:0 10px"
												v-if="templateId === 2"
											>
												<div style="margin-top: 5px;">
													<b style="font-size: 16px;word-break: break-all;">{{ formData.name
														||
														$t('createForm.formData.name')}}</b>
													<br>
													<span style="word-break: break-all;">{{ formData.position ||
															$t('createForm.formData.position')}}</span>,
													<span style="word-break: break-all;">{{ formData.company ||
															$t('createForm.formData.company')}}</span>
												</div>
												<div style="margin-top: 10px; font-size:13px;">
													<b>Office: </b>
													<span style="word-break: break-all;">{{ formData.companyAddress ||
															$t('createForm.formData.companyAddress')}}</span>
												</div>
												<div style="margin-top: 5px; font-size:13px;">
													<b>Email: </b>
													<span style="display:inline-block; word-break: break-all;">
												<a :href="generateEmailHref(formData.email)"
												   style="color:#008EFF;"
												>{{ formData.email || 'example@mail.com' }}</a>
											</span>
												</div>
												<div style="margin-top: 5px; font-size:13px;">
													<b>Web: </b>
													<span>
												<a :href="formData.site"
												   style="color:#008EFF; word-break: break-all;"
												>{{ formData.site || $t('createForm.formData.site') }}</a>
											</span>
												</div>
											</td>
										</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>

		<div class="cropper__generate--wrap">
			<button
				class="NS-button NS-button__gradient NS-button__gradient__darkSkyBlue cropper__generate__btn"
				:disabled="!fullFormData || isGenerated"
				:class="{disabled: !fullFormData || isGenerated}"
				@click.prevent="generateSignature"
			>
				<i class="fa fa-refresh"
				   :class="{'fa-spin': isGenerated}"
				></i>{{ $t('cropper.generateBtn') }}
			</button>

			<p class="cropper__generate__text">
				{{ $t('cropper.generateText') }}
			</p>
		</div>

	</div>
</template>

<script>

	import {clipperBasic, clipperPreview} from 'vuejs-clipper';
	import Api from '../Api/image.js'
	import {zoomPreviewMixin} from "@/plugin/zoomPreview";

	export default {
		data() {
			return {
				counter: 0,
				img: null,
				resultURL: null,
				fileName: null,
				fileExtension: null,
				newImage: null,
				isGenerated: false,
				error: false,
				errorText: '',
				isDrag: false,
				isListenUnload: false
			}
		},
		computed: {
			fullFormData() {
				return Object.values(this.formData).every(_ => _) && !!this.img;
			},
			imageWidth() {
				return this.templateId === 1 ? 70 : 100
			}
		},
		methods: {
			generateEmailHref(email) {
				return `mailto:${email}`
			},
			async generateSignature() {
				this.isGenerated = true;

				const sleep = (milliseconds) => {
					return new Promise(resolve => setTimeout(resolve, milliseconds))
				};

				try {
					const canvas = this.$refs.clipper.clip();
					if (canvas.width < this.imageWidth) throw 'wrongSize';

					const DATA = {
						image: canvas.toDataURL(`image/${this.fileExtension}`, 1),
						fileName: this.fileName,
						extension: this.fileExtension,
						size: this.imageWidth
					};

					const RES = await Api.upload_image(DATA);
					this.resultURL = RES.data.url;

					await sleep(1000);
					const HTML = this.$refs.previewSignature.innerHTML
						.replace('<!---->', '')
						.replace('class=""', '');
					await this.$store.dispatch('prettyCode', HTML);

					setTimeout(() => {
						this.isGenerated = false;
						this.$scrollTo('#generated');
					}, 500)

				} catch (e) {
					if (e === 'wrongSize') {
						this.error = true;
						this.errorText = this.$t('cropper.errorText').split('%size%').join(this.imageWidth);
						this.isGenerated = false;
					}
					console.log(e);
					console.log(e.response);
				}

			},
			upload: function (e) {
				if (e.files.length !== 0) {
					this.error = false;
					const fileSize = e.files[0].size / 1024 / 1024;
					if (fileSize > 5) {
						this.errorText = this.$t('cropper.sizeErrorText');
						this.error = true;
						return false;
					}
					this.fileName = e.files[0].name.replace(/\..*/, '');
					this.fileExtension = e.files[0].name.split('.')[1];
					this.resultURL = null;
					if (this.img) URL.revokeObjectURL(this.img);
					this.img = window.URL.createObjectURL(e.files[0]);
				}
			},
			toggleUnloadListener() {
				const isEmptyForm = () =>
					Object.keys(this.formData)
						.every(el => !!!this.formData[el]) && !!!this.img;

				const unloadFunction = e => {
					const dialogText = 'Dialog text here';
					e.returnValue = dialogText;
					return dialogText;
				};
				window.onbeforeunload = !isEmptyForm()
					? function (e) {
						const dialogText = 'Dialog text here';
						e.returnValue = dialogText;
						return dialogText;
					}
					: null;
			},
			initListeners() {
				window.addEventListener('dragenter', () => this.isDrag = true);
				window.addEventListener('dragleave', e => {
					e.preventDefault();
					this.isDrag = false
				});
				window.addEventListener('dragover', e => {
					e.preventDefault();
					this.isDrag = true;
				});
				window.addEventListener('drop', e => {
					e.preventDefault();
					this.isDrag = false;
				});

				this.$refs.cropper.addEventListener('drop', e => {
					e.preventDefault();
					this.isDrag = false;
					const files = e.dataTransfer.files;
					const fakeEvent = {
						files: Object.values(files).filter(el => /\.(jpe?g|png|gif)$/i.test(el.name))
					};
					this.upload(fakeEvent)
				});
			}
		},
		watch: {
			templateId() {
				this.$nextTick(() => {
					this.zoomPreview()
				})
			},
			formData: {
				handler: function () {
					this.toggleUnloadListener();
				},
				deep: true
			},
			img() {
				this.toggleUnloadListener();
			}
		},
		mounted() {
			this.initListeners();
		},
		mixins: [zoomPreviewMixin],
		components: {
			clipperBasic,
			clipperPreview,
		},
		props: ['formData', 'templateId'],
	}
</script>
